import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import apiInstanceV2 from "../../Apis/AxiosV2";
import { TRAFFIC_FINE_SERVICE } from '../EndPoints';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

export const GetGeofenceById = createAsyncThunk('trafficFine/getGeofenceById', async (id, { dispatch, getState }) => {
    const response = await apiInstance.get(`${TRAFFIC_FINE_SERVICE.getGeofenceById}${id}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateGeofence = createAsyncThunk("trafficFine/createGeofence",async (params, { dispatch, getState }) => {
    const response = await apiInstance.post(TRAFFIC_FINE_SERVICE.createGeofence, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateGeofence = createAsyncThunk("trafficFine/updateGeofence",async (params, { dispatch, getState }) => {
    const response = await apiInstance.put(TRAFFIC_FINE_SERVICE.updateGeofence, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetGeofenceList = createAsyncThunk('trafficFine/getGeofenceList', async (params, { dispatch, getState }) => {
    const result = await apiInstanceV2
        .get(TRAFFIC_FINE_SERVICE.getGeofenceList)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const UpdateGeofenceHierarchyLevel = createAsyncThunk("trafficFine/updateGeofenceHierarchyLevel",async (params, { dispatch, getState }) => {
    const response = await apiInstance.put(TRAFFIC_FINE_SERVICE.updateGeofenceHierarchyLevel, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateGeofenceStatus = createAsyncThunk("trafficFine/updateGeofenceStatus",async (params, { dispatch, getState }) => {
    const response = await apiInstance.put(TRAFFIC_FINE_SERVICE.updateGeofenceStatus, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetGeofenceConfigSettingByGeofenceId = createAsyncThunk("trafficFinesSection/GetGeofenceConfigSetting",async (params, { dispatch, getState }) => {

    const response = await apiInstance.get(`${TRAFFIC_FINE_SERVICE.getGeofenceConfigSettingByGeofenceId}${params}`).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});
